import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPageBrandLogoStyles {
    container?: GridContainerProps;
    brandGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
}

export const pageBrandLogoStyles: ProductDetailsPageBrandLogoStyles = {
    container: {
        gap: 0,
    },
    brandGridItem: {
        width: 12,
        css: css`
            a {
                margin-bottom: 15px;
                margin-right: 15px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            margin-bottom: 0px;
                            margin-right: 15px;
                        `,
                    css`
                            margin-bottom: 0px;
                            margin-right: 15px;
                        `,
                    css`
                            margin-bottom: 0px;
                            margin-right: 15px;
                        `,
                    null,
                ])}
            }
        `,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    width: 100%;
                    transition: all 0.2s ease;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
            css: css`
                color: #2e64b0;
                &:hover {
                    color: #25518e;
                }
            `,
        },
    },
};

const styles = pageBrandLogoStyles;

const ProductDetailsBrandLogo: React.FC<Props> = ({ product }) => {
    return (
        <GridContainer {...styles.container}>
            {product.brand && (
                <GridItem {...styles.brandGridItem}>
                    <ProductBrand brand={product.brand} showLogo={true} extendedStyles={styles.brandStyles} />
                </GridItem>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsBrandLogo),
    definition: {
        displayName: "Brand Logo",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
